import { ArrowRight, BookOpen, Clock, Gamepad2, Languages, LinkIcon, Loader2, Mail, Play, Search, Upload, Youtube, Zap } from "lucide-react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import GetGameName from "../GetGamesName";
import ExtractGamePoster from "../GetGamePoster";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import logo from '../../../assets/images/gamizign logo adobe com without text 500p.webp'
import LanguageSwitcher from "../LanguagePicker";

const GoldCourseNew = () => {
    const {i18n} = useTranslation();    
    const isRtl = i18n.language==='ar';
    const [step, setStep] = useState(1);
    const [ingestMode, setIngestMode] = useState('upload');
    const [processProgress, setProcessProgress] = useState(0);
    const [lang, setLang] = useState('en');
    const {language} = i18n;
    const [url, setUrl] = useState('');
    const [selectedGame, setSelectedGame] = useState('');
    const [pastedText, setPastedText] = useState('');
    const [topic, setTopic] = useState('');
    const [isDragging, setIsDragging] = useState(false);
    const [files, setFiles] = useState(null);
    const [GAME_TEMPLATES, setGAME_TEMPLATES] = useState(GetGameName);
    const [noResourseError, setNoResourseError] = useState('');
    const [isPlay, setIsPlay] = useState(false);
    const fileRef = useRef(null);
    // let token = Cookies.get("token");
    let token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhc29sYW5naTM1NUBnbWFpbC5jb20iLCJleHAiOjE3NzI4MDk1Mzd9.pV_PEkYqjw-RSaoLQD35Vq5oJvLsC0qEBZl6h0HJtf8';
        let tokenTrim = (token.substring(token.indexOf(" "), token.length)).trimStart();
    const link = `https://games.gamizign.com/?instructor=${1}&course=${912}&token=${tokenTrim}&lang=${i18n.language}&quickJoin=${false}`
    const t = {
    en: {
      heroTitle: "Boring Lessons? Fix it in 60 Seconds.",
      heroSub: "Stop spending 5 hours planning for a 1-hour class. Drop your slides, a YouTube link, or a topic, and let AI build the engagement for you.",
      playNow: "Play a Demo",
      fixLesson: "Fix My Lesson",
      cta: "Generate Game Concepts",
      processing: "AI is crafting your experience...",
      selectTitle: "Choose Your Arena",
      whyThis: "Why this game?",
      saveGame: "Save Game & Get Code",
      gateTitle: "Love the result?",
      gateSub: "Enter your email to get your student join code and save this game forever.",
      placeholder: "Enter your email",
      finish: "Claim My Game",
      uploadTab: "Upload",
      topicTab: "Topic",
      pasteTab: "Paste",
      urlTab: "Link/YouTube",
      urlPlaceholder: "Paste YouTube link or Article URL...",
      saveTime :"Save 10+ hours of prep weekly",
      Gamizign: "Gamizign",
      LivePreview: "Live Preview",
      ChallengeFriends: "Challenge your friends! Create your own game for free on Gamizign!",
      TryNow: "Try it now",
      GameLoaded: "Game Loaded Successfully!",
      GameLoadedP1: "This is where your custom questions from",
      GameLoadedP2: "are now playable.",
      StartRound: "START MINI-ROUND",
      Back: "← Back",
      AlreadyUser: "Already a user?",
      GamizignAi: "Gamizign AI - Rapid Instructional Design Engine"

    },
    ar: {
      heroTitle: "دروس مملة؟ أصلحها في 60 ثانية.",
      heroSub: "توقف عن قضاء 5 ساعات في التخطيط لحصة مدتها ساعة واحدة. ضع شرائحك، أو رابط يوتيوب، أو فكرة، واترك الذكاء الاصطناعي يبني التفاعل لك.",
      playNow: "العب ديمو الآن",
      fixLesson: "أصلح درسي الآن",
      cta: "إنشاء مفاهيم اللعبة",
      processing: "الذكاء الاصطناعي يصمم تجربتك...",
      selectTitle: "اختر ساحتك",
      whyThis: "لماذا هذه اللعبة؟",
      saveGame: "حفظ اللعبة والحصول على الرمز",
      gateTitle: "هل أعجبتك النتيجة؟",
      gateSub: "أدخل بريدك الإلكتروني للحصول على رمز انضمام الطلاب وحفظ هذه اللعبة للأبد.",
      placeholder: "أدخل بريدك الإلكتروني",
      finish: "احصل على لعبتي",
      uploadTab: "رفع",
      topicTab: "موضوع",
      pasteTab: "لصق",
      urlTab: "رابط / يوتيوب",
      urlPlaceholder: "رابط يوتيوب أو مقال...",
      saveTime :"وفر أكثر من 10 ساعات من التحضير أسبوعياً",
      Gamizign: "جيميزاين",
      LivePreview: "المعاينة المباشرة",
      ChallengeFriends: "تحدَّ أصدقاءك! أنشئ لعبتك الخاصة مجاناً على جيميزاين!",
      TryNow: "جربه الآن",
      GameLoaded: "تم تحميل اللعبة بنجاح!",
      GameLoadedP1: "هنا يمكنك طرح أسئلتك المخصصة من",
      GameLoadedP2: "أصبحت قابلة للعب الآن.",
      StartRound: "ابدأ الجولة المصغرة",
      Back: "→ العودة",
      AlreadyUser: "هل أنت مستخدم بالفعل؟",
      GamizignAi: "محرك تصميم تعليمي سريع بتقنية جيميزاين AI"
    }
  };
    const handleStartAI = () => {
        setStep(2);
        setProcessProgress(0);

        let progress = 0;

        const interval = setInterval(() => {
            progress += 1;
            setProcessProgress(progress);

            if (progress >= 100) {
                clearInterval(interval);
                setStep(3);
            }
        }, 30); // speed (lower = faster)
    };
    const validationHandle = () => {
        if (files || pastedText || url || topic) {
            handleStartAI();
        }else{
           setNoResourseError('Kindly attach file or write topic.'); 
        }
    };
    // 
    const handlefileClicked =  () => {
        fileRef.current.click();
    }
 
    const onFileChange = (e) => {
        const copyFile = e.target.files[0];
        setFiles(copyFile);
        setNoResourseError('');
    }
    const onFileDrop = (e) => {
        const efile = e.dataTransfer.files[0];
        setFiles(efile);
        setNoResourseError('');

    };
    const handleTextFieldChange = (value, type) => {
        setNoResourseError('');
        if (type==='url') {
            setUrl(value);
            return; 
        }
        if (type==='pasteText') {
            setPastedText(value);
           return; 
        }
        if (type==='topic') {
            setTopic(value);
           return; 
        }
    }

    console.log(step);
    console.log(files);
    

    return (
        <div className={`min-h-screen bg-slate-50 font-sans text-slate-900 p-4 md:p-8 ${isRtl ? 'rtl' : 'ltr'}`} dir={isRtl ? 'rtl' : 'ltr'}>
            {/* Navbar */}
            <header className="max-w-6xl mx-auto flex justify-between items-center mb-8">
                <div className="flex items-center gap-2 cursor-pointer" onClick={() => setStep(1)}>
                        <img className="w-12" src={logo} alt="logo" />
                    {/* <div className="bg-indigo-600 p-2 rounded-xl shadow-lg shadow-indigo-200">
                        <Zap className="text-white w-6 h-6 fill-current" />
                    </div> */}
                    <h1 className="text-2xl font-black tracking-tighter text-indigo-950 uppercase">{language==='en'&&'Gami'}<span className="text-indigo-600">{language==='ar'?'جيميزاين':'zign'}</span></h1>
                </div>
                <LanguageSwitcher />
                {/* <button
                    onClick={() => setLang(lang === 'en' ? 'ar' : 'en')}
                    className="flex items-center gap-2 bg-white border border-slate-200 px-4 py-2 rounded-full text-sm font-bold hover:bg-slate-50 transition"
                >
                    <Languages className="w-4 h-4" />
                    {lang === 'en' ? 'العربية' : 'English'}
                </button> */}
            </header>

            <main className="max-w-5xl mx-auto">

                {/* STEP 1: CATCHY PAIN-POINT HERO */}
                {step === 1 && (
                    <div className="animate-in fade-in slide-in-from-bottom-8 duration-700">
                        <div className="text-center mb-12 space-y-8">
                            <div className="inline-flex items-center gap-2 bg-amber-50 text-amber-700 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-wider border border-amber-100">
                                <Clock className="w-3.5 h-3.5" /> {t[language].saveTime}
                            </div>
                            <h2 className="text-5xl md:text-7xl font-black text-slate-900 leading-[1.1] tracking-tight">
                                {t[language].heroTitle}
                            </h2>
                            <p className="text-xl text-slate-500 max-w-2xl mx-auto font-medium">
                                {t[language].heroSub}
                            </p>

                            <div className="flex flex-wrap items-center justify-center gap-4">
                                <button
                                    onClick={() => { setSelectedGame(GAME_TEMPLATES[0]); setStep(4); }}
                                    className="bg-slate-900 text-white px-8 py-4 rounded-2xl font-black flex items-center gap-3 hover:scale-105 transition shadow-xl"
                                >
                                    <Play className="w-5 h-5 fill-current" /> {t[language].playNow}
                                </button>
                                <button
                                    onClick={() => {
                                        const el = document.getElementById('creation-zone');
                                        el?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                    className="bg-white border-2 border-indigo-600 text-indigo-600 px-8 py-4 rounded-2xl font-black hover:bg-indigo-50 transition"
                                >
                                    {t[language].fixLesson}
                                </button>
                            </div>
                        </div>

                        <div id="creation-zone" className="bg-white rounded-[40px] shadow-2xl p-2 border border-slate-100 overflow-hidden mt-12">
                            {/* 4-Tab Switcher including URL */}
                            <div className="flex p-1.5 bg-slate-100 rounded-[34px] mb-8 max-w-2xl mx-auto mt-6 overflow-x-auto scrollbar-hide">
                                {[
                                    { id: 'upload', icon: <Upload className="w-4 h-4" />, label: t[language].uploadTab },
                                    { id: 'paste', icon: <BookOpen className="w-4 h-4" />, label: t[language].pasteTab },
                                    { id: 'url', icon: <Youtube className="w-4 h-4" />, label: t[language].urlTab },
                                    { id: 'topic', icon: <Search className="w-4 h-4" />, label: t[language].topicTab },
                                ].map((tab) => (
                                    <button
                                        key={tab.id}
                                        className={`flex - 1 min-w-fit flex items-center justify-center gap-2 py-3 px-6 rounded-[28px] font-bold transition-all text-sm whitespace-nowrap ${ingestMode === tab.id ? 'bg-white shadow-md text-indigo-600' : 'text-slate-500 hover:text-slate-700'}`}
                                        onClick={() => setIngestMode(tab.id)}
                                    >
                                        {tab.icon} {tab.label}
                                    </button>
                                ))}
                            </div>

                            <div className="p-8 pt-0">
                                {ingestMode === 'upload' && (
                                    <div
                                        onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                                        onDragLeave={() => setIsDragging(false)}
                                        onDrop={(e) => { e.preventDefault();onFileDrop(e) }}
                                        className={`border-4 border-dashed rounded-[32px] p-4 py-8 sm:p-12 flex flex-col items-center justify-center transition-all ${isDragging ? 'border-indigo-500 bg-indigo-50' : 'border-slate-200 bg-slate-50/50'
                                            }`}
                                    >
                                        <div onClick={handlefileClicked}
                                         className="bg-white p-6 rounded-3xl shadow-xl mb-6 cursor-pointer">
                                            <label className="cursor-pointer" htmlFor="fileInput">

                                            <Upload className="w-12 h-12 text-indigo-600" />
                                            </label>
                                            <input
                                                type="file"
                                                // type={inputType}
                                                ref={fileRef}
                                                id="fileInput"
                                                className="absolute h-0 w-0 overflow-hidden"
                                                accept=".pptx, .pdf"
                                                onChange={onFileChange}
                                                // onClick={handleValidation}
                                            />
                                        </div>
                                        <p className="text-2xl font-black text-slate-800 mb-2">{isRtl ? 'اسحب الملفات هنا' : 'Drop your files'}</p>
                                        <p className="text-2xl font-black text-slate-800 mb-2">{files?.name}</p>
                                    </div>
                                )}

                                {ingestMode === 'paste' && (
                                    <div className="bg-slate-50/50 border-4 border-slate-100 rounded-[32px] p-6">
                                        <textarea
                                            value={pastedText}
                                            onChange={(e) => handleTextFieldChange(e.target.value,'pasteText')}
                                            placeholder={t[language].pastePlaceholder}
                                            className="w-full h-48 bg-white border-2 border-slate-200 rounded-[24px] p-6 text-lg font-medium focus:border-indigo-500 focus:outline-none shadow-sm transition-all resize-none"
                                        />
                                    </div>
                                )}

                                {ingestMode === 'url' && (
                                    <div className="bg-slate-50/50 border-4 border-slate-100 rounded-[32px] p-4 py-8 sm:p-12 text-center">
                                        <div className="max-w-xl mx-auto space-y-4">
                                            <div className="flex gap-4 justify-center mb-6">
                                                <div className="p-4 bg-white rounded-2xl shadow-sm border border-slate-100">
                                                    <Youtube className="text-red-600 w-8 h-8" />
                                                    </div>
                                                <div className="p-4 bg-white rounded-2xl shadow-sm border border-slate-100">
                                                    <LinkIcon className="text-blue-600 w-8 h-8" />
                                                    </div>
                                            </div>
                                            <input
                                                type="text"
                                                value={url}
                                                onChange={(e) => handleTextFieldChange(e.target.value,'url')}
                                                placeholder={t[language].urlPlaceholder}
                                                className={`w-full bg-white border-2 border-slate-200 rounded-[24px] py-6 px-4 sm:px-8 text-lg font-bold focus:border-indigo-500 focus:outline-none shadow-sm transition-all`}
                                            />
                                        </div>
                                    </div>
                                )}

                                {ingestMode === 'topic' && (
                                    <div className="bg-slate-50/50 border-4 border-slate-100 rounded-[32px] p-4 py-8 sm:p-12">
                                        <div className="max-w-2xl mx-auto">
                                            <input
                                                type="text"
                                                value={topic}
                                                onChange={(e) => handleTextFieldChange(e.target.value,'topic')}
                                                placeholder={t[language].topicPlaceholder}
                                                className={`w-full bg-white border-2 border-slate-200 rounded-[24px] py-6 px-4 sm:px-8 text-xl font-bold focus:border-indigo-500 focus:outline-none shadow-sm transition-all`}
                                            />
                                        </div>
                                    </div>
                                )}
                                {/* Validation error message */}
                                {noResourseError && <p className="text-red-600 font-bold text-center">{noResourseError}</p>}

                                <div className="mt-10">
                                    <button
                                        onClick={validationHandle}
                                        className="w-full bg-indigo-600 text-white py-6 rounded-[24px] font-black text-2xl flex items-center justify-center gap-4 hover:bg-indigo-700 shadow-xl shadow-indigo-100 active:scale-[0.98] transition-all"
                                    >
                                        {t[language].cta} <ArrowRight className={isRtl ? 'rotate-180' : ''} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
                }

                {/* STEP 2: PROCESSING */}
                {
                    step === 2 && (
                        <div className="bg-white rounded-[40px] shadow-xl p-20 text-center animate-in zoom-in-95">
                            <Loader2 className="w-24 h-24 text-indigo-600 animate-spin mx-auto mb-10" />
                            <h2 className="text-3xl font-black mb-6">{t[language].processing}</h2>
                            <div className="w-full bg-slate-100 h-6 rounded-full max-w-md mx-auto overflow-hidden p-1">
                                <div className="bg-indigo-600 h-full rounded-full transition-all duration-300" style={{ width: `${processProgress}%` }} />
                            </div>
                        </div>
                    )
                }

                {/* STEP 3: SELECTION */}
                {
                    step === 3 && (
                        <div className="animate-in slide-in-from-bottom-8 duration-500">
                            <h2 className="text-4xl font-black text-slate-900 mb-10">{t[language].selectTitle}</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                {GAME_TEMPLATES.map((game, index) => (
                                    <div key={game.id} className="bg-white rounded-[32px] overflow-hidden shadow-lg border-2 border-transparent hover:border-indigo-500 transition-all group flex flex-col"
                                    style={{backgroundImage:`url(${ExtractGamePoster(index)})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover',}}
                                    >
                                        <div className={`h-48 bg-gradient-to-br ${game.color} flex items-center justify-center text-white relative`}>
                                            <Play className="w-16 h-16 opacity-0 group-hover:opacity-100 transition-opacity z-10" />
                                        </div>
                                        <div className="p-8 flex-1 flex flex-col">
                                            <h3 className="text-2xl font-black mb-2">{language === 'ar' ? game.nameAr : game.name}</h3>
                                            <p className="text-slate-500 text-sm mb-6 flex-1">{game.description}</p>
                                            <button onClick={() => { setSelectedGame(game); setStep(4); }} className="w-full bg-slate-900 text-white py-4 rounded-xl font-bold hover:bg-indigo-600 transition">{language === 'ar' ? 'اختر هذه اللعبة' : 'Select This Game'}</button>
                                        </div></div>))}</div></div>)
                }
                {/* STEP 4: PREVIEW + GATE + VIRAL HOOK */}
                {
                    step === 4 && (<div className="space-y-8 animate-in fade-in duration-500">
                        <div className="flex justify-between items-center">
                        <button onClick={() => {setStep(isPlay?4:3);setIsPlay(false)}} className="text-slate-400 font-bold hover:text-indigo-600">{t[language].Back}</button>
                        <h3 className="text-2xl font-black">{selectedGame} <span className="text-indigo-600">{t[language].LivePreview}</span></h3>
                        <div /></div>
                        <div className="relative group"></div>
                        <div className="bg-[#1a1a1a] rounded-[32px] shadow-2xl aspect-video border-[8px] border-white ring-1 ring-slate-200 relative group">
                            {!isPlay &&<div id="unity-container" className="w-full h-full relative overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-b from-slate-800 to-black flex flex-col items-center justify-center p-12 text-center rounded-[32px]">
                            <Gamepad2 className="w-20 h-20 text-indigo-500 mb-6 animate-bounce" />
                            <h4 className="text-white text-xl sm:text-3xl font-black mb-2">{t[language].GameLoaded}</h4>
                            <p className="text-white/40 max-w-sm">{t[language].GameLoadedP1} {ingestMode} {t[language].GameLoadedP2}</p>
                            <button onClick={()=>setIsPlay(true)} className="sm:mt-8 bg-indigo-600 text-white px-10 py-4 rounded-2xl sm:font-black">{t[language].StartRound}</button>
                            </div>
                            <div className="absolute top-0 left-0 right-0 bg-indigo-600/90 text-white py-3 px-6 transform -translate-y-full group-hover:translate-y-0 transition-transform duration-500 backdrop-blur-sm z-20 flex justify-between items-center rounded-t-[26px]">
                            <p className="text-xs font-bold">{t[language].ChallengeFriends}</p>
                            <button className="bg-white text-indigo-600 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-tight">{t[language].TryNow}</button>
                            </div>
                            </div>}
                            <div className={`${isPlay ? 'w-full h-screen' : 'w-1 h-1' } p-5 py-0`}>
                        <iframe
                            src={link}
                            title="Ai-magic"
                            className="w-full h-full"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                            </div>
                        <div className="bg-indigo-600 rounded-[32px] p-10 text-white shadow-2xl shadow-indigo-200">
                            <div className="max-w-2xl relative z-10">
                            <h2 className="text-4xl font-black mb-4">{t[language].gateTitle}</h2>
                            <p className="text-indigo-100 text-lg mb-8 font-medium">{t[language].gateSub}</p>
                            <div className="flex flex-col md:flex-row gap-4">
                                <div className="flex-1 relative">
                                    <Mail className={`absolute ${isRtl ? 'right-4' : 'left-4'} top-1 /2 -translate-y-1/2 text-indigo-300 w-5 h-5`} />
                                    <input type="email" placeholder={t[language].placeholder} className={`w-full bg-white /10 border border-white/20 rounded-2xl py-5 px-6 text-indigo-600 placeholder:text-indigo-300 focus:outline-none focus:ring-2 focus:ring-white/50 font-bold`} /></div>
                                <button className="bg-white text-indigo-600 px-10 py-5 rounded-2xl font-black text-xl hover:bg-indigo-50 transition shadow-xl">{t[language].finish}</button>
                            </div></div></div></div>)
                }
                </main >
                <div className="flex justify-center mt-10">
                <Link to='/'>{t[language].AlreadyUser}</Link>
                </div>
            <footer className="max-w-6xl mx-auto mt-14 text-center text-slate-400 pb-12 font-medium">
                {/* <p>© 2026 Gamizign AI - Rapid Instructional Design Engine</p> */}
                <p>© {new Date().getFullYear()} {t[language].GamizignAi}</p>
            </footer>
        </div >
    );
};

export default GoldCourseNew;